module.exports = __webpack_public_path__ + "static/media/fn-logo2.8d502372.png";